var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAwardThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_1438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6 12C12.6928 12 15.2 9.49278 15.2 6.39999C15.2 3.30719 12.6928 0.799988 9.6 0.799988C6.50721 0.799988 4 3.30719 4 6.39999C4 9.49278 6.50721 12 9.6 12Z",
    stroke: "#EC5569",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56761 11.112L5.59961 18.4L9.59961 16L13.5996 18.4L12.6316 11.104",
    stroke: "#EC5569",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_1438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwardThin);
export default __webpack_public_path__ + "static/media/icon-award-thin.79ecd4a5046517cb9e0c109a8c300e15.svg";
export { ForwardRef as ReactComponent };